import { render, staticRenderFns } from "./BlockedCall.vue?vue&type=template&id=077d4310&"
import script from "./BlockedCall.vue?vue&type=script&lang=js&"
export * from "./BlockedCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports